import { render, staticRenderFns } from "./invite_modal.vue?vue&type=template&id=01a905aa&scoped=true"
import script from "./invite_modal.vue?vue&type=script&lang=js"
export * from "./invite_modal.vue?vue&type=script&lang=js"
import style0 from "./invite_modal.vue?vue&type=style&index=0&id=01a905aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a905aa",
  null
  
)

export default component.exports